(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[228],{

/***/ 96183:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buy",
      function () {
        return __webpack_require__(59468);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 27419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72006);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4405);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77637);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74098);





function TabPanel(props) {
    var children = props.children, value = props.value, index = props.index, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, [
        "children",
        "value",
        "index"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        role: "tabpanel",
        hidden: value !== index,
        id: "simple-tabpanel-".concat(index),
        "aria-labelledby": "simple-tab-".concat(index)
    }, other), {
        children: value === index && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            p: 3,
            children: children
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (TabPanel);


/***/ }),

/***/ 59468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(57135);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(57389);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(72006);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(77637);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(15767);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84902);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78174);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59496);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(55051);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(95017);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(30277);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(2733);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(27245);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(21849);
/* harmony import */ var _auth0_auth0_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95682);
/* harmony import */ var mixpanel_browser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56530);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(111);
/* harmony import */ var rehype_external_links__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(19559);
/* harmony import */ var _material_ui_icons_WidgetsSharp__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(81982);
/* harmony import */ var _material_ui_icons_CameraSharp__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(99637);
/* harmony import */ var _material_ui_icons_AspectRatioSharp__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(10);
/* harmony import */ var _utils_authLib__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61852);
/* harmony import */ var _components_AppState__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66791);
/* harmony import */ var _utils_formatAppLib__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(57870);
/* harmony import */ var _components_TabPanel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27419);
/* harmony import */ var _utils_users__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19399);
/* harmony import */ var _utils_theme__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9564);
/* harmony import */ var _utils_useAuth__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(74216);















// End server-side imports










var ProductTypes = Object.freeze({
    PACKAGES: 0,
    CREDITS: 1,
    FRAMES: 2
});
var _obj, _obj1;
var pricingTableIds =  true ? (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, ProductTypes.PACKAGES, "prctbl_1PTJuFGuk7YU2S0SoaTne296"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, ProductTypes.CREDITS, "prctbl_1PTK0SGuk7YU2S0SyoOzyQPC"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, ProductTypes.FRAMES, "prctbl_1PTK45Guk7YU2S0SJqABBSYf"), _obj) : (0);
var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function(theme) {
    return {
        tabs: {
            backgroundColor: theme.palette.accent.main,
            boxShadow: "none",
            border: "1px solid " + theme.palette.secondary.light
        },
        tab: {
            height: "48px",
            minWidth: 100
        },
        indicator: {
            top: "0px",
            height: "100%",
            backgroundColor: "grey",
            opacity: 0.1
        },
        image: {
            width: "80%",
            display: "block",
            margin: "0 auto"
        }
    };
});
function FaqImage(props) {
    var classes = useStyles();
    var node = props.node, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(props, [
        "node"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
        className: classes.image
    }, rest));
}
function Buy(param) {
    var pricingTableFaqs = param.pricingTableFaqs;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,_utils_useAuth__WEBPACK_IMPORTED_MODULE_11__/* .useAuth */ .a)(), isAuthenticated = ref.isAuthenticated, user = ref.user;
    var clientSecret = (0,_utils_users__WEBPACK_IMPORTED_MODULE_9__/* .useStripeClientSecret */ .xQ)().clientSecret;
    var classes = useStyles();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_components_AppState__WEBPACK_IMPORTED_MODULE_7__/* .AppContext */ .I), galleryUser = ref1.galleryUser, isAccountLoaded = ref1.isAccountLoaded;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(ProductTypes.PACKAGES), productType = ref2[0], setProductType = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isQueryLoaded = ref3[0], setIsQueryLoaded = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null), redirect = ref4[0], setRedirect = ref4[1];
    var isSelfUser = user && user.sub === galleryUser;
    var isSelfUserReady = user && galleryUser;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        mixpanel_browser__WEBPACK_IMPORTED_MODULE_5__/* ["default"].track */ .Z.track("View Buy");
        document.body.style.backgroundColor = _utils_theme__WEBPACK_IMPORTED_MODULE_10__/* ["default"].palette.accent.main */ .Z.palette.accent.main;
        return function() {
            // FIXME: This is a hack to reset the background color. We should at least make sure that the background
            // from the global theme is the same colour.
            document.body.style.backgroundColor = _utils_theme__WEBPACK_IMPORTED_MODULE_10__/* ["default"].palette.primary.background */ .Z.palette.primary.background;
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        // Handle direct product type URL, if set
        if (!router.isReady) return;
        if (!isAuthenticated) return;
        if (!isAccountLoaded) return;
        // if (isQueryLoaded) return;
        setIsQueryLoaded(true);
        var productTypeQuery = router.query["p"];
        if (productTypeQuery) {
            var productTypeIndex = ProductTypes[productTypeQuery.toUpperCase()];
            if (productTypeIndex !== undefined) {
                setProductType(productTypeIndex);
            }
        }
    }, [
        isAuthenticated,
        router.isReady,
        isAccountLoaded,
        router.query,
        isQueryLoaded
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var script = document.createElement("script");
        script.src = "https://js.stripe.com/v3/pricing-table.js";
        script.async = true;
        document.body.appendChild(script);
        return function() {
            document.body.removeChild(script);
        };
    }, []);
    function updateProductType(productType) {
        return _updateProductType.apply(this, arguments);
    }
    function _updateProductType() {
        _updateProductType = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(productType) {
            var newUrlParams, oldQueryString, newProductQuery, newQueryString;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                setProductType(productType);
                if (router.isReady) {
                    newUrlParams = new URLSearchParams(window.location.search);
                    oldQueryString = newUrlParams.toString();
                    newProductQuery = Object.keys(ProductTypes).find(function(key) {
                        return ProductTypes[key] === productType;
                    }).toLowerCase();
                    newUrlParams.set("p", newProductQuery);
                    newQueryString = newUrlParams.toString();
                    if (newQueryString !== oldQueryString) {
                        if (newQueryString.length > 0) {
                            router.replace(window.location.pathname + "?" + newQueryString);
                        } else {
                            router.replace(window.location.pathname);
                        }
                    }
                }
                return [
                    2
                ];
            });
        });
        return _updateProductType.apply(this, arguments);
    }
    if (!isAuthenticated) {
        return null;
    }
    if (redirect) {
        router.push(redirect);
    }
    var rehypeNewTabOpts = {
        target: "_blank",
        rel: [
            "nofollow",
            "nopener",
            "noreferrer"
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: "Bandicoot - App - Buy"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                maxWidth: "xl",
                children: [
                    isSelfUserReady && !isSelfUser && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        variant: "subtitle1",
                        color: "error",
                        children: "Purchasing is disabled when acting as another user."
                    }),
                    isSelfUser && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                position: "static",
                                className: classes.tabs,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                    value: productType,
                                    onChange: function(event, newValue) {
                                        updateProductType(newValue);
                                    },
                                    indicatorColor: "secondary",
                                    textColor: "secondary",
                                    variant: "fullWidth",
                                    classes: {
                                        indicator: classes.indicator
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                            value: ProductTypes.PACKAGES,
                                            className: classes.tab,
                                            label: "Scan Packages",
                                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_WidgetsSharp__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {})
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                            value: ProductTypes.CREDITS,
                                            className: classes.tab,
                                            label: "Credit Packs",
                                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_CameraSharp__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {})
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                            value: ProductTypes.FRAMES,
                                            className: classes.tab,
                                            label: "PRO Frames",
                                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_AspectRatioSharp__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {})
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_TabPanel__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                value: productType,
                                index: ProductTypes.PACKAGES,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stripe-pricing-table", {
                                        "pricing-table-id": pricingTableIds[ProductTypes.PACKAGES],
                                        "publishable-key": "pk_live_Eo9YbtQPhtxLT3lxjSybE6WK003OLJDHKT",
                                        "client-reference-id": (0,_utils_formatAppLib__WEBPACK_IMPORTED_MODULE_26__/* .cleanUserId */ .YY)(user.sub),
                                        "customer-session-client-secret": clientSecret
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        maxWidth: "sm",
                                        style: {
                                            paddingTop: "3em"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                            color: "secondary",
                                            component: "span",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_27__/* .ReactMarkdown */ .D, {
                                                components: {
                                                    img: FaqImage
                                                },
                                                rehypePlugins: [
                                                    [
                                                        rehype_external_links__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z,
                                                        rehypeNewTabOpts
                                                    ]
                                                ],
                                                children: pricingTableFaqs[ProductTypes.PACKAGES]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_TabPanel__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                value: productType,
                                index: ProductTypes.CREDITS,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stripe-pricing-table", {
                                        "pricing-table-id": pricingTableIds[ProductTypes.CREDITS],
                                        "publishable-key": "pk_live_Eo9YbtQPhtxLT3lxjSybE6WK003OLJDHKT",
                                        "client-reference-id": (0,_utils_formatAppLib__WEBPACK_IMPORTED_MODULE_26__/* .cleanUserId */ .YY)(user.sub),
                                        "customer-session-client-secret": clientSecret
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        maxWidth: "sm",
                                        style: {
                                            paddingTop: "3em"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                            color: "secondary",
                                            component: "span",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_27__/* .ReactMarkdown */ .D, {
                                                components: {
                                                    img: FaqImage
                                                },
                                                rehypePlugins: [
                                                    [
                                                        rehype_external_links__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z,
                                                        rehypeNewTabOpts
                                                    ]
                                                ],
                                                children: pricingTableFaqs[ProductTypes.CREDITS]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_TabPanel__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                value: productType,
                                index: ProductTypes.FRAMES,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stripe-pricing-table", {
                                        "pricing-table-id": pricingTableIds[ProductTypes.FRAMES],
                                        "publishable-key": "pk_live_Eo9YbtQPhtxLT3lxjSybE6WK003OLJDHKT",
                                        "client-reference-id": (0,_utils_formatAppLib__WEBPACK_IMPORTED_MODULE_26__/* .cleanUserId */ .YY)(user.sub),
                                        "customer-session-client-secret": clientSecret
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        maxWidth: "sm",
                                        style: {
                                            paddingTop: "3em"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                            color: "secondary",
                                            component: "span",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_27__/* .ReactMarkdown */ .D, {
                                                components: {
                                                    img: FaqImage
                                                },
                                                rehypePlugins: [
                                                    [
                                                        rehype_external_links__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z,
                                                        rehypeNewTabOpts
                                                    ]
                                                ],
                                                children: pricingTableFaqs[ProductTypes.FRAMES]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,_auth0_auth0_react__WEBPACK_IMPORTED_MODULE_4__/* .withAuthenticationRequired */ .u3)(Buy, {
    onBeforeAuthentication: function() {
        (0,_utils_authLib__WEBPACK_IMPORTED_MODULE_6__/* .logAuthenticationRequired */ .R)("Buy");
    }
}));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [99,25,726,774,888,179], function() { return __webpack_exec__(96183); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);